import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {NotificacionWebSocket} from '@app/domain/notificacion-web';
import {EventEnum} from '@app/enums/event.enum';
import {NotificacionWebService} from '@app/service/notificacion-web.service';
import {SocketIoService} from '@app/service/socket-io.service';

@Component({
    selector: 'app-notification-count-badge',
    template: `
        <span *ngIf="unopenedCount > 0"
              class="notification-menu-badge"
              [attr.aria-label]="unopenedCount + ' notificaciones sin abrir'">
            {{ badgeText }}
        </span>
    `,
    styleUrls: ['./notification-count-badge.component.scss']
})
export class NotificationCountBadgeComponent implements OnInit, OnDestroy {

    unopenedCount = 0;

    private readonly destroy$ = new Subject<void>();

    constructor(private notificationService: NotificacionWebService,
                private socketIoService: SocketIoService) {
    }

    ngOnInit(): void {
        this.refreshUnopenedCount();
        this.socketIoService.onEvent(EventEnum.NOTIFICATION)
            .pipe(takeUntil(this.destroy$))
            .subscribe(event => this.handleSocketNotification(event));
    }

    get badgeText(): string {
        return this.unopenedCount > 99 ? '+99' : this.unopenedCount.toString();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private handleSocketNotification(event: any): void {
        const notification = (event?.value || event) as NotificacionWebSocket;
        if (!notification || notification.idEmpresa == null || !notification.codigo) {
            return;
        }
        this.refreshUnopenedCount();
    }

    private refreshUnopenedCount(): void {
        this.notificationService.countUnopened().subscribe({
            next: response => {
                this.unopenedCount = response.notificacionesSinAbrir || 0;
            }
        });
    }
}
